import {
    Component,
    ChangeDetectionStrategy,
    Input,
    EventEmitter,
    Output,
    ChangeDetectorRef,
    ViewEncapsulation,
    signal,
    ViewChild,
    OnInit,
    computed,
} from "@angular/core";
import { Debounce } from "../../../../decorators/debounce.decorator";
import { EventService } from "../../../../services/event.service";
import { PopoverComponent } from "../../../s25-popover/popover.component";
import { OccurrenceI } from "../../../../pojo/OccurrenceI";
import { S25ProfileUtil } from "../../utils/s25.profile.util";
import { S25EventOccurrencesService } from "../s25.event.occurrences.service";
import { S25Util } from "../../../../util/s25-util";
import { S25Reservation, S25RmReservation, S25RsReservation } from "../../ReservationI";
import { S25ModalComponent } from "../../../s25-modal/s25.modal.component";
import { EvOccMappingComponent } from "../../../../standalone/ev-occ-mapping.component";
import { S25Profile, RecordType } from "../../ProfileI";
import { Flavor } from "../../../../pojo/Util";
import { S25DatePatternPickerComponent } from "../../../s25-datepattern/s25.datepattern.picker.component";
import { ReservationService } from "../../../../services/reservation.service";
import { S25ObjectSearchComponent } from "../../../s25-object-search/s25.object.search.component";
import { Item } from "../../../../pojo/Item";
import {
    S25OjectSearchUtil,
    AvailLocationItems,
    AvailResourceItems,
} from "../../../s25-object-search/s25.object.search.util";
type AddItemType = AvailLocationItems | AvailResourceItems;
import { EventOccUtil } from "../s25-event-occurrence/s25.event.occurrence.util";

/**
 * Displays gear icon, lets the user select between 'seperated' and 'merged view'. migration of evdo-menu
 * OTHER NOTES:
 * Commented out "Delete This Segment"  event micro service current not support this feature
 * ACCL-1752 getting very large, don't want adding any new functionality
 *
 */
@Component({
    selector: "s25-ng-occ-menu",
    template: `
        <div class="occ-menu-wrapper" [class.single-profile]="!multiProfiles">
            @if (multiProfiles && ((isSeparatedView && isFirstSegment) || !isSeparatedView)) {
                <div class="occ-menu">
                    <button
                        class="view-select-button c-margin-right--half"
                        [ngClass]="{
                            'aw-button aw-button--primary': !isSeparatedView,
                            'c-textButton': isSeparatedView,
                        }"
                        (click)="onViewChange()"
                    >
                        Merged View
                    </button>
                    <button
                        class="view-select-button"
                        [ngClass]="{
                            'aw-button aw-button--primary': isSeparatedView,
                            'c-textButton': !isSeparatedView,
                        }"
                        (click)="onViewChange()"
                    >
                        Segment View
                    </button>
                </div>
            }

            @if (!multiProfiles) {
                <div class="view-select-button aw-button aw-button--primary aw-button-cursor-default">Segment View</div>
            }

            @if (canEdit) {
                @if (isSeparatedView || !multiProfiles) {
                    <button class="aw-button aw-button--outline" (click)="copySegment()">Copy This Segment</button>
                    <s25-ng-modal #occMappingModal [title]="'Copy Segment Occurrence Mapping'" [size]="'xl'">
                        <ng-template #s25ModalBody>
                            <s25-ng-occ-mapping
                                #occMappingComp
                                [startDate]="startDate"
                                [endDate]="endDate"
                                [rsrvs]="rsrvs"
                                [sourceProfileCode]="profileCode"
                                (modelValueChange)="onCopySegmentSubmit($event)"
                            >
                            </s25-ng-occ-mapping>
                        </ng-template>
                    </s25-ng-modal>
                }
                <!-- add a new segment -->
                <button class="aw-button aw-button--outline" (click)="addSegment()">Add a New Segment</button>
                <s25-ng-modal #newSegmentFormModal [title]="'Add a New Segment'" [size]="'xl'">
                    <ng-template #s25ModalBody>
                        <div class="three-column-layout">
                            <div class="date-time-section" [ngClass]="{ 'modal-spaces': !addModalSpace() }">
                                @if (profileName()) {
                                    <s25-ng-editable-text
                                        class="segmentName"
                                        [allowEmpty]="false"
                                        [min]="2"
                                        [max]="40"
                                        [alwaysEditing]="true"
                                        [val]="profileName()"
                                        (valChange)="profileName.set($event)"
                                    ></s25-ng-editable-text>

                                    @if (!isCopySegment()) {
                                        <s25-ng-editable-start-end-datetime
                                            [startDatetime]="startDate"
                                            (startDatetimeChange)="onDateTimeChange($event, 'start')"
                                            [endDatetime]="endDate"
                                            (endDatetimeChange)="onDateTimeChange($event, 'end')"
                                            [noTimeUpdated]="true"
                                        >
                                        </s25-ng-editable-start-end-datetime>

                                        <div class="occ-menu-pattern">
                                            <s25-ng-date-pattern-picker
                                                #datePicker
                                                [timeModel]="{
                                                    evStartDt: startDate,
                                                    evEndDt: endDate,
                                                    minutes: {
                                                        setupMinutes: 0,
                                                        preMinutes: 0,
                                                        postMinutes: 0,
                                                        takedownMinutes: 0,
                                                    },
                                                }"
                                                [minDate]="endDate"
                                                [showAdHocList]="false"
                                                (apiBeanChange)="onDatePatternChange($event)"
                                            ></s25-ng-date-pattern-picker>
                                        </div>
                                    }

                                    <button
                                        class="aw-button aw-button--outline c-margin-top--half submit-button "
                                        (click)="onSubmit()"
                                    >
                                        Submit
                                    </button>
                                }
                            </div>
                            <div class="add-locations">
                                <div>
                                    <button class="aw-button aw-button--outline" (click)="onObjectSearch(4)">
                                        Add Locations
                                    </button>
                                    <div class="c-margin-top--single">
                                        @for (location of locations[0]?.reserved; track location) {
                                            <s25-ng-icon
                                                [type]="'close'"
                                                [label]="'Delete'"
                                                (click)="removedItem(4, location.itemId)"
                                            ></s25-ng-icon>
                                            <span class="c-margin-right--single"></span>
                                            <s25-item-space
                                                [modelBean]="{ itemId: location.itemId, itemName: location.itemName }"
                                                [includeTypeIcon]="true"
                                            ></s25-item-space>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="add-resources">
                                <div>
                                    <button class="aw-button aw-button--outline" (click)="onObjectSearch(6)">
                                        Add Resources
                                    </button>
                                    <div class="c-margin-top--single">
                                        @for (resource of resources[0]?.reserved; track resource) {
                                            <s25-ng-icon
                                                [type]="'close'"
                                                [label]="'Delete'"
                                                (click)="removedItem(6, resource.itemId)"
                                            ></s25-ng-icon>
                                            <span class="c-margin-right--single"></span>
                                            <s25-item-resource
                                                [modelBean]="{
                                                    itemId: resource.itemId,
                                                    itemName: resource.itemName,
                                                }"
                                                [includeTypeIcon]="true"
                                            ></s25-item-resource>

                                            <div class="res-qty">Quantity: {{ resource?.quantity }}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </s25-ng-modal>

                <s25-ng-modal
                    #objectSearchModal
                    [title]="itemTypeId === 4 ? 'Locations Search' : 'Resources Search'"
                    [size]="'xl'"
                >
                    <ng-template #s25ModalBody>
                        <s25-ng-object-search
                            #objectSearchComponent
                            [itemTypeId]="itemTypeId"
                            [occ]="newRsrvsData[0]"
                            [profileId]="newProfileId()"
                            [eventId]="eventId"
                            [selectedItems]="newRsrvsIds"
                            [newProfile]="newProfileTemp"
                            (refreshF)="onItemsChanges($event, itemTypeId)"
                        >
                        </s25-ng-object-search>
                    </ng-template>
                </s25-ng-modal>
            }

            @if (canEdit && isSeparatedView) {
                @if (multiProfiles) {
                    <button class="aw-button aw-button--danger--outline" (click)="deleteSegment()">
                        Delete This Segment
                    </button>
                }
            }
            @if (!multiProfiles || (isSeparatedView && isFirstSegment) || !isSeparatedView) {
                <button class="aw-button aw-button--outline" (click)="expandAllToggle()">
                    {{ isExpandAll ? "Collapse All" : "Expand All" }}
                </button>
            }
        </div>
    `,
    styles: [
        `
            .occ-menu-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-block: 15px;
            }

            .occ-menu-wrapper.single-profile {
                margin-block: 1rem;
            }

            .occ-menu {
                font-size: 16px !important;
                font-weight: 600;
            }

            .nm-party--on {
                .occ-menu {
                    color: #fff;
                }

                .c-start-end-datetime-picker--wrapper {
                    box-shadow: unset !important;
                }
            }

            .view-select-button.aw-button.aw-button--primary {
                font-size: unset !important;
                border-radius: 7px;
            }

            .date-time-section {
                padding: 10px 20px 20px 20px;
                font-weight: normal !important;
                font-size: 15px;
                display: flex;
                flex-direction: column;
                gap: 10px; /* Space between elements inside the date-time section */
            }

            .date-time-section .occ-menu-pattern {
                display: flex;
                flex-direction: row;
                justify-content: left;
                padding: 20px 0px;
                font-size: 15px;

                s25-ng-date-pattern-picker label {
                    width: 100% !important;
                }

                s25-ng-date-pattern .repeats-every {
                    display: inline-block;
                }
            }

            .aw-button-cursor-default:hover {
                cursor: default !important;
                text-decoration: none !important;
            }

            .three-column-layout {
                display: flex;
                justify-content: space-between; /* Distribute the space between the columns */
                gap: 20px; /* Optional: Adjust space between columns */
            }

            .date-time-section,
            .add-locations,
            .add-resources {
                flex: 1; /* Each section will take equal width */
                min-width: 0; /* Prevents flex items from overflowing */
            }

            .add-locations,
            .add-resources {
                display: flex;
                align-items: flex-start;
                justify-content: left;
                padding: 10px;
                font-weight: normal !important;
                font-size: 15px;
                /* border: 1px solid #ccc; */ /* Optional: Add a border around the sections */
            }

            .submit-button {
                width: 80px;
            }

            :host ::ng-deep .s25-item-holder {
                display: flex;
                align-items: center;
            }

            .res-qty {
                font-size: 13px;
                margin-bottom: 10px;
                margin-left: 65px;
            }

            .modal-spaces {
                padding-bottom: 200px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EvOccMenuComponent implements OnInit {
    @Input() isSeparatedView: boolean;
    @Input() profileId?: number;
    @Input() canEdit?: boolean = false;
    @Input() multiProfiles?: boolean = false;
    @Input() startDate?: Date;
    @Input() endDate?: Date;
    @Input() isFirstSegment: boolean = false;
    @Input() eventId?: number;
    @Output() modelValueChange: EventEmitter<EvOccMenuOutput> = new EventEmitter<EvOccMenuOutput>();
    @ViewChild("occMappingComp") occMappingComp: EvOccMappingComponent;
    @ViewChild("occMappingModal") occMappingModal: S25ModalComponent;
    @ViewChild(PopoverComponent) popover: PopoverComponent;
    @ViewChild("newSegmentFormModal") newSegmentFormModal: S25ModalComponent;
    @ViewChild("datePicker") datePicker: S25DatePatternPickerComponent;
    @ViewChild("objectSearchComponent") objSearchComp: S25ObjectSearchComponent;
    @ViewChild("objectSearchModal") objectSearchModal: S25ModalComponent;

    init: boolean = false;
    profileName = signal<string>("");
    newProfileId = signal<number>(null);
    isCopySegment = signal<boolean>(false);
    mapping: OccurrenceI.Mapping = "one-by-one";
    profile: S25Profile;
    rsrvs: S25Reservation[];
    isExpandAll: boolean = false;
    profileCode: string = "";
    pattern: Flavor<string, "repeating pattern">;
    itemTypeId: number;
    newRsrvsData: S25Reservation[];
    newProfileCode: string;
    newRsrvsIds: number[] = [];
    newProfileTemp: S25Profile;
    locations: S25RmReservation[] = [];
    resources: S25RsReservation[] = [];

    constructor(
        private cd: ChangeDetectorRef,
        private eventOccurrencesService: S25EventOccurrencesService,
    ) {}

    callerTags = computed(() => {
        return this.eventOccurrencesService.getCallerTags();
    });

    ngOnInit() {
        this.init = true;
        this.cd.detectChanges;
    }

    @Debounce(300) // Avoid double calls
    async copySegment() {
        const profile = S25ProfileUtil.getProfileByProfileId(
            this.eventOccurrencesService.getProfiles() as S25Profile[],
            this.profileId,
        ) as S25Profile;
        if (profile?.occurrenceDefn?.recTypeId === RecordType.RecurrenceGrammar)
            this.profileCode = profile?.occurrenceDefn?.profileCode;
        this.rsrvs = profile.reservations as S25Reservation[];
        this.isSeparatedView = true;
        this.isCopySegment.set(true);
        this.occMappingModal.open();
    }

    //go to seperated view and indicate that a new segment is added
    async addSegment() {
        // reset temp profile , locations and resources  when open modal
        this.locations = [];
        this.resources = [];
        this.newProfileTemp = undefined;
        this.newProfileId.set(await EventService.getNewProfileId());
        this.profileName.set("Segment_" + this.newProfileId());
        this.isCopySegment.set(false);
        await this.newSegmentFormModal.open();
        await this.getDatePickerData();
    }

    @Debounce(300) // Avoid double calls
    async onSubmit() {
        await this.getDatePickerData();
        const data: dataI = {
            startDate: this.startDate,
            endDate: this.endDate,
            profileName: this.profileName(),
            profileId: this.newProfileId(),
            isCopySegment: this.isCopySegment(),
            newProfileCode: this.newProfileCode,
            addNewOccs: this.newRsrvsData,
            newProfile: this.newProfileTemp,
        };
        this.isSeparatedView = true;
        this.newProfileTemp.itemName = this.profileName();
        if (this.newProfileTemp.occurrenceDefn.recTypeId === RecordType.RecurrenceGrammar) {
            this.newProfileTemp.occurrenceDefn.profileCode = this.newProfileCode;
        } else if (this.newProfileTemp.occurrenceDefn.recTypeId === RecordType.SingleDateTime) {
            this.newProfileTemp.occurrenceDefn.profileCode = EventOccUtil.setSingleProfieCode(this.startDate as Date);
        }
        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: true, data: data });
        this.newSegmentFormModal?.close();
    }

    onCopySegmentSubmit(data: dataI) {
        (data.sourceProfileId = this.profileId), (data.isCopySegment = true);
        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: true, data: data });
        this.occMappingModal.close();
    }

    onDateTimeChange(newDate: Date, text: "start" | "end") {
        if (text === "start") {
            this.startDate = newDate;
            this.pattern && this.pattern !== "dnr" && this.datePicker.changeFirstDt(newDate);
        } else {
            this.endDate = newDate;
        }
    }

    onViewChange() {
        const data = {
            profileId: this.profileId,
        };
        this.isSeparatedView = !this.isSeparatedView;
        this.modelValueChange.emit({ isSeparatedView: this.isSeparatedView, addNew: false, data: data });
    }

    @Debounce(300) // Avoid double calls
    deleteSegment() {
        this.isSeparatedView = true;
        this.modelValueChange.emit({
            isSeparatedView: this.isSeparatedView,
            addNew: false,
            data: { profileId: this.profileId },
            isDelete: true,
        });
    }

    refresh() {
        this.init = false;
        this.cd.detectChanges();
        this.init = true;
        this.cd.detectChanges();
    }

    expandAllToggle() {
        this.isExpandAll = !this.isExpandAll;
        this.eventOccurrencesService.setExpandAll(!this.isExpandAll);
        const elements: any = this.callerTags()
            ? document.querySelectorAll(this.callerTags())
            : document.querySelectorAll(this.isSeparatedView ? ".occ-expand-all" : ".occ-expand-all-segment");
        for (let i = 0; i < elements.length; ++i) {
            elements[i].click();
        }
        this.cd.detectChanges();
    }

    onDatePatternChange(apiBean: any) {
        this.pattern = apiBean.getProfileCode();
        this.cd.detectChanges();
    }

    async onItemsChanges(selectItem: AddItemType[], itemTypeId: number) {
        const updateReservedData = (
            data: AddItemType[] | undefined,
            itemType: "resource" | "space",
        ): ReservationItem[] => {
            if (!Array.isArray(data)) {
                return [];
            }

            return data.map((item) => ({
                itemId: item[`${itemType}Id`],
                itemName: item[`${itemType}Name`],
                ...(itemType === "resource" ? { quantity: item.quantity } : { isShare: item.share }),
            }));
        };

        //  add or update the reservation S25RmReservation||S25RsReservation[]
        const addOrUpdateReserved = (
            reservedArray: Array<S25RmReservation | S25RsReservation>,
            newItems: ReservationItem[],
        ): void => {
            if (reservedArray.length > 0) {
                reservedArray[0].reserved.push(...newItems);
            } else {
                reservedArray.push({ reserved: [...newItems], requested: [], draft: [] });
            }
        };

        if (itemTypeId === Item.Ids.Resource) {
            const res = updateReservedData(selectItem, "resource");
            addOrUpdateReserved(this.resources, res);
        } else {
            const loc = updateReservedData(selectItem, "space");
            addOrUpdateReserved(this.locations, loc);
        }

        await this.resetRsrv();

        this.eventOccurrencesService.deleteTempProfile(this.newProfileTemp.itemId);

        this.objectSearchModal.close();
    }

    async getDatePickerData() {
        this.newProfileCode = await this.datePicker.getProfileCode();
        const occs = await this.datePicker.getOccurrences();
        const recType = occs.length === 1 ? 0 : this.newProfileCode === "adhoc" ? 2 : 1;
        if (["dnr", "adhoc"].includes(this.newProfileCode)) this.newProfileCode = "";
        const item = await ReservationService.generateReservationIds(occs.length);
        this.newRsrvsData = occs.map((occ, i) => {
            const start: Date = occ.evStartDt || (occ as any);
            const end: Date = occ.evEndDt || (occ as any);
            let eventStart = start;
            let eventEnd = end;
            if (recType === RecordType.AdHoc) {
                eventStart = S25Util.date.copyTime(new Date(start), this.startDate);
                eventEnd = S25Util.date.copyTime(new Date(end), this.endDate);
            }
            return {
                itemId: item?.idSet[i].rsrvId,
                state: 1,
                eventStart: eventStart,
                eventEnd: eventEnd,
                locations: this.locations,
                resources: this.resources,
                profileId: this.newProfileId(),
                profileName: this.profileName(),
                occurrence: S25Util.date.toS25ISODateStr(eventStart),
            } as S25Reservation;
        });
        await this.getProfileTemp(recType);
    }

    async onObjectSearch(id: number) {
        await this.getDatePickerData();
        this.newRsrvsIds = S25Util.toItemIds(this.newRsrvsData);
        this.itemTypeId = id;
        this.objectSearchModal.open();
    }

    async getProfileTemp(recType: RecordType) {
        if (!this.newProfileTemp) {
            this.newProfileTemp = await S25ProfileUtil.createEmptyProfile(
                this.startDate,
                this.endDate,
                this.profileName(),
                this.newProfileId(),
                this.newProfileCode,
                recType,
            );
        } else {
            this.newProfileTemp.occurrenceDefn.recTypeId = recType;
            this.newProfileTemp.occurrenceDefn.initStartDt = S25Util.date.toS25ISODateTimeStr(this.startDate);
            this.newProfileTemp.occurrenceDefn.initEndDt = S25Util.date.toS25ISODateTimeStr(this.endDate);
        }

        this.newProfileTemp.reservations = this.newRsrvsData;

        if (this.newProfileTemp.occurrenceDefn.recTypeId === RecordType.AdHoc) {
            const adHocDates = this.newRsrvsData.map((item) => S25Util.date.toS25ISODateStr(item.eventStart));
            this.newProfileTemp.occurrenceDefn.adHocDates = S25Util.array.uniqueDeep(adHocDates);
        }
    }

    async resetRsrv() {
        this.newRsrvsData.forEach((occ) => {
            occ.locations = this.locations;
            occ.resources = this.resources;
        });
        this.newProfileTemp.reservations = this.newRsrvsData;
    }

    async removedItem(itemTypeId: number, itemId: number) {
        if (itemTypeId === Item.Ids.Resource) {
            this.resources[0].reserved = this.resources[0].reserved.filter((item) => item.itemId !== itemId);
        } else {
            this.locations[0].reserved = this.locations[0].reserved.filter((item) => item.itemId !== itemId);
        }
        await this.resetRsrv();
        this.cd.detectChanges();
    }

    addModalSpace(): boolean {
        return this.pattern === undefined || this.pattern === "ndr" || this.pattern === "adhoc";
    }
}

export type EvOccMenuOutput = {
    isSeparatedView: boolean;
    data?: dataI;
    addNew: boolean;
    isDelete?: boolean;
};

export type dataI = {
    profileId?: number;
    profileName?: string;
    startDate?: Date;
    endDate?: Date;
    sourceProfileId?: number;
    mapping?: OccurrenceI.Mapping;
    isCopySegment?: boolean;
    newCopyRsrvsData?: S25Reservation[];
    newProfileCode?: string;
    addNewOccs?: S25Reservation[];
    newProfile?: S25Profile;
};

interface ReservationItem {
    itemId: number;
    itemName: string;
    quantity?: number;
    isShare?: boolean;
}
